import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import React from 'react';
import { useContext } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';

const FindLangKey = (key, observer = '') => {
  const [text, setText] = useState('');
  const languageArray =
    useContext(GlobalContext)?.LanguageArray;

  useMemo(() => {
    if (languageArray?.length > 0) {
      const ObjIndex = languageArray?.findIndex(
        (obj) => obj.FormKey === key
      );
      setText(
        languageArray[ObjIndex]?.Value?.length > 0
          ? ArabicToPersian(languageArray[ObjIndex]?.Value)
          : ArabicToPersian(languageArray[ObjIndex]?.Key)
      );
    }
  }, [JSON.stringify(languageArray), observer]);

  return text;
};

export default FindLangKey;
